import { render, staticRenderFns } from "./wankaInfo.vue?vue&type=template&id=a714d052&scoped=true"
import script from "./wankaInfo.vue?vue&type=script&lang=js"
export * from "./wankaInfo.vue?vue&type=script&lang=js"
import style0 from "./wankaInfo.vue?vue&type=style&index=0&id=a714d052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a714d052",
  null
  
)

export default component.exports